const api = '/api/v1/u012_r_w_category_controller.php';
import axios from 'axios';
export const w_category_repository =  {
    get(user_id){
        return  axios.get(`${api}?USER_ID=${user_id}`);
    },
    upd(data){
        return  axios.post(api, data);
    },
    del(id){
        return  axios.delete(`${api}?ID=${id}`);
    }
};

